module.exports = __webpack_public_path__ + "static/img/11areaA_05.21763c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_05.png
// module id = 999
// module chunks = 1